/**
 * The top bar's call-to-action per page (prototype `HeaderView.actionsFor`).
 */
import { Button, Icon } from '@deepdive-ui';
import type { ReactNode } from 'react';

import type { TopBarKind } from '@/app/router/registry';
import { useAppDispatch, useAppSelector } from '@/store/hooks';
import { cancelSettings, openDialog, requestSettingsSave } from '@/store/slices/uiSlice';

export function useTopBarActions(kind: TopBarKind, onExport: () => void): ReactNode {
  const dispatch = useAppDispatch();
  const settingsDirty = useAppSelector((state) => state.ui.settings.dirty);

  switch (kind) {
    case 'module':
      return (
        <Button hierarchy="primary" onClick={onExport} aria-haspopup="dialog">
          Export
        </Button>
      );
    case 'reports-list':
      return (
        <Button
          hierarchy="primary"
          iconLeading={<Icon name="add" />}
          onClick={() => dispatch(openDialog('create-report'))}
          aria-haspopup="dialog"
        >
          Create a report
        </Button>
      );
    case 'deepdive-home':
      return (
        <Button
          hierarchy="tertiary"
          href="/deepdive-ai/history"
          iconLeading={<Icon name="chatHistory" />}
        >
          Chat history
        </Button>
      );
    case 'deepdive-chat':
      return (
        <>
          <Button
            hierarchy="tertiary"
            href="/deepdive-ai/history"
            iconLeading={<Icon name="chatHistory" />}
          >
            Chat history
          </Button>
          <Button hierarchy="secondary" href="/deepdive-ai">
            New chat
          </Button>
        </>
      );
    case 'settings':
      return (
        <>
          <Button
            hierarchy="tertiary"
            disabled={!settingsDirty}
            onClick={() => dispatch(cancelSettings())}
          >
            Cancel
          </Button>
          <Button
            hierarchy="primary"
            disabled={!settingsDirty}
            onClick={() => dispatch(requestSettingsSave())}
          >
            Save changes
          </Button>
        </>
      );
    case 'report-detail':
    case 'deepdive-history':
    case 'quick-search':
    case 'influencer-detail':
      return undefined;
  }
}
